/**
 * MUI theme font — resolves to --layerd-font-sans (defined in public/fonts/rubik.css).
 * Do not set fontFamily on individual components; inherit from html / theme.typography.
 */
export const RUBIK_FONT_STACK = "var(--layerd-font-sans)";

/** Literal stack for ApexCharts / SVG (cannot use CSS variables in inline chart styles). */
export const RUBIK_FONT_FAMILY_APEX = '"Rubik", ui-sans-serif, system-ui, sans-serif';
